import {
  Button,
  Drawer,
  Form,
  Space,
  Input,
  InputNumber,
  TimePicker,
  DatePicker,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo } from "../../../../context";
import dayjs from "dayjs";
import moment from "moment";

const EditOvertime = ({ open, close, rerun, selectedData }) => {
  const { rerunNotif } = useContext(NotificationInfo);
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const [timeIn, setTimeIn] = useState(
    selectedData.ot_time_in !== null ? selectedData.ot_time_in : null
  );
  const [timeOut, setTimeOut] = useState(
    selectedData.ot_time_out !== null ? selectedData.ot_time_out : null
  );
  const [currentDate, setCurrentDate] = useState(
    selectedData.ot_date !== null
      ? dayjs(selectedData.ot_date, "YYYY-MM-DD")
      : null
  );

  const handleEditOvertime = (values) => {
    const formdata = new FormData();
    formdata.append("id", selectedData !== null ? selectedData.id : "");
    formdata.append("ot_time_in", timeIn !== null ? timeIn : null);
    formdata.append("ot_time_out", timeOut !== null ? timeOut : null);
    formdata.append("ot_minutes", getMinutesDifference(timeIn, timeOut));
    formdata.append("ot_date", currentDate !== null ? currentDate : "");

    setLoading(true);
    axios
      .post("user/merchant/update/edit-overtime", formdata)
      .then((response) => {
        const data = response.data;
        if (data.message === "success") {
          rerunNotif("success", "Edited overtime successfully.");
          setTimeout(() => {
            rerun();
            setLoading(false);
            close();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoading(false);
      });
  };

  function getMinutesDifference(timeFrom, timeTo) {
    const fromTime = moment(timeFrom, "HH:mm:ss");
    let toTime = moment(timeTo, "HH:mm:ss");
    if (toTime.isBefore(fromTime)) {
      toTime.add(1, "day");
    }
    const differenceInMinutes = toTime.diff(fromTime, "minutes");
    return differenceInMinutes;
  }

  return (
    <Drawer
      title="Edit Overtime"
      onClose={close}
      open={open}
      bodyStyle={{
        paddingBottom: 80,
      }}
    >
      {selectedData !== null && (
        <Form
          form={form}
          layout="vertical"
          name="edit-ovetime"
          initialValues={{
            time_in:
              selectedData.ot_time_in !== null
                ? dayjs(selectedData.ot_time_in, "HH:mm:ss")
                : null,
            time_out:
              selectedData.ot_time_out !== null
                ? dayjs(selectedData.ot_time_out, "HH:mm:ss")
                : null,
            ot_date:
              selectedData.ot_date !== null
                ? dayjs(selectedData.ot_date, "YYYY-MM-DD")
                : null,
          }}
          onFinish={handleEditOvertime}
          autoComplete="off"
        >
          <Space direction="vertical" style={{ width: "100%", margin: 0 }}>
            <Form.Item
              name="ot_date"
              label="Date"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <DatePicker
                format={"MM/DD/YYYY"}
                size="large"
                style={{ width: "100%" }}
                onChange={(e) =>
                  setCurrentDate(moment(new Date(e)).format("YYYY-MM-DD"))
                }
              />
            </Form.Item>

            <Form.Item
              name="time_in"
              label="Time in"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <TimePicker
                format={"HH:mm"}
                onChange={(value, dateString) => {
                  if (dateString !== "") {
                    var date = `2023-11-23 ${dateString}:00`;
                    var finalDate = moment(`${date.replace(" ", "T")}.000000Z`)
                      .utc()
                      .format("HH:mm:ss");
                    setTimeIn(finalDate);
                  } else {
                    setTimeIn(null);
                  }
                }}
                size="large"
                required
                style={{ width: "100%" }}
              />
            </Form.Item>

            <Form.Item
              name="time_out"
              label="Time out"
              rules={[
                {
                  required: true,
                  message: "Required",
                },
              ]}
            >
              <TimePicker
                format={"HH:mm"}
                onChange={(value, dateString) => {
                  if (dateString !== "") {
                    var date = `2023-11-23 ${dateString}:00`;
                    var finalDate = moment(`${date.replace(" ", "T")}.000000Z`)
                      .utc()
                      .format("HH:mm:ss");
                    setTimeOut(finalDate);
                  } else {
                    setTimeOut(null);
                  }
                }}
                size="large"
                required
                style={{ width: "100%" }}
              />
            </Form.Item>
          </Space>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              //   loading={loading}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
              //   disabled={timeIn === null}
            >
              {loading ? "Loading" : "Update"}
            </Button>
          </Form.Item>
        </Form>
      )}
    </Drawer>
  );
};

export default EditOvertime;
